
export default {
  name: 'ScrollPane',
  values: {
    direction: undefined,
    nativeScroll: true,
    mouseDragScroll: false,
    scrollBarYDirectionOff: false,
    scrollBarXDirectionOff: false,
    _mobile_scrollBarXDirectionOff: true,
    display: undefined,
    width: undefined,
    scrollBarWidth: 'auto',
  },
  meta: {
    extendable: false,
  },
}
